<template>
  <div class="home">
    <a-spin size="large" :spinning="loading" class="draft-con">
      <div class="no-data-box" v-if="!(tableData && tableData.length)">
        <NoData :lang="lang" :text="$t('noDraft')" />
      </div>
      <template v-else>
        <a-table
          :class="{ arTable: lang == 'AR' ? true : false }"
          class="custom-scrollbar capinTable"
          size="middle"
          :columns="columns"
          :rowKey="(record, index) => index"
          :data-source="tableData"
          :pagination="false"
          :loading="tableLoading"
          :locale="{ emptyText: $t('noDraft') }"
          :row-class-name="
            (_record, index) => (index % 2 !== 1 ? 'table-bg' : null)
          "
        >
          <template slot="action" slot-scope="text, record" class="arial">
            <a-dropdown>
              <template #overlay>
                <a-menu>
                  <a-menu-item key="0" @click="goEdit(record)">
                    <a-icon type="form" />
                    <span :class="[lang]">{{ $t("campaignEdit") }}</span>
                  </a-menu-item>
                  <a-menu-item key="3" @click="deleteHandler(record)">
                    <a-icon type="delete" />
                    <span :class="[lang]">{{ $t("Delete") }}</span>
                  </a-menu-item>
                </a-menu>
              </template>
              <a-button style="padding: 0 8px" @click.stop="clickHandler">
                <span :class="[lang]">{{ $t("Action") }}</span>
                <a-icon type="down" />
              </a-button>
            </a-dropdown>
          </template>
        </a-table>
        <div v-if="showPagination">
          <app-footer
            :current="page"
            :pageSize="pageSize"
            :total="total"
            @onPageChange="onPageChange"
            @onPageSizeChange="onPageSizeChange"
          ></app-footer>
        </div>
      </template>
    </a-spin>
  </div>
</template>

<script>
import BaseComponent from "@/components/base.component";

export default {
  data() {
    return {
      loading: false,
      tableLoading: false,
      tableData: [],
    };
  },
  i18n: require("./i18n"),
  mixins: [BaseComponent],
  computed: {
    columns: {
      get() {
        let that = this;
        return [
          {
            title: that.$t("draftId"),
            width: 100,
            dataIndex: "itemKey",
            align: "center",
          },
          {
            title: that.$t("Name"),
            minWidth: 100,
            dataIndex: "campaign_name",
            // align: "center",
            ellipsis: true,
            // fixed: "left",
            scopedSlots: {
              customRender: "campaign_name",
            },
          },
          {
            title: that.$t("LinkedinlD"),
            minWidth: 100,
            dataIndex: "linkedin_account",
            ellipsis: true,
            align: "center",
          },
          {
            title: that.$t("lastSavedTime"),
            width: 180,
            dataIndex: "last_saved_time",
            align: "center",
          },

          {
            title: that.$t("Action"),
            align: "center",
            fixed: "right",
            width: 120,
            scopedSlots: {
              customRender: "action",
            },
          },
        ];
      },
    },
    // 是否展示分页
    showPagination() {
      if (this.pageSize < this.total) {
        return true;
      }
      return false;
    },
  },
  created() {},
  activated() {
    this.initData();
  },
  methods: {
    clickHandler() {
      this.writeLog("campaign", "sales", "click_action");
    },
    initData() {
      this.getData(true);
    },
    handleChange() {
      this.page = 1;
      this.getData();
    },
    // 删除
    deleteHandler(record) {
      let that = this;
      this.$confirm({
        title: that.$t("delDraftTip"),
        // content: h => <div style="color:red;">Some descriptions</div>,
        onOk() {
          that.writeLog("campaign", "sales", "click_action_delete");
          that
            .$axios(
              "/recruiter/campaign_delete",
              { campaign_id: record.id },
              "post"
            )
            .then((res) => {
              if (res.code == 200) {
                if (that.tableData.length == 1 && that.page > 1) {
                  that.page--;
                  that.getData();
                } else {
                  that.getData();
                }
              }
            });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },
    // 获取列表数据
    getData(type) {
      let postData = {
        page: this.page,
        page_size: this.pageSize,
      };
      if (type) {
        this.loading = true;
      }
      this.tableLoading = true;
      this.$axios("/sales/draft_list", postData, "post")
        .then((res) => {
          this.loading = false;
          this.tableLoading = false;
          if (res.code == 200) {
            let { list, total_num, page_size } = res.data || {};
            this.detailData = res.data;
            let arr = [];
            list.forEach((item, index) => {
              item.itemKey = (this.page - 1) * this.pageSize + (index + 1);
              arr.push(item);
            });
            this.tableData = list;
            this.total = total_num;
            this.pageCount = Math.ceil(total_num / page_size);
          }
        })
        .catch((e) => {
          console.log(e);
          this.loading = false;
          this.tableLoading = false;
        });
    },
    // 编辑
    goEdit(record) {
      this.writeLog("campaign", "sales", "click_action_edit");
      let { id } = record;
      this.$router.push({
        path: "/sales/salesReps/createCampaign",
        query: {
          campaign_id: id,
          edit: 3,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  //margin-top: 50px;
  padding: 20px 30px;
  min-height: calc(100vh - 64px - 90px);
  .draft-con {
    padding: 20px 20px 12px;
    background: #fff;
    border-radius: 4px;
    min-height: calc(100vh - 64px - 90px - 40px);
    position: relative;
    /deep/.no-data-box {
      min-height: calc(100vh - 64px - 90px - 40px);
    }
    /deep/.noData {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }
    /deep/.ant-btn {
      background: #0c6158;
      color: #fff;
    }
  }
}
</style>
